import { whenDocumentReady } from '../../../../assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    Fancybox.bind('[data-fancybox]');
}
